export type HeaderData = {
  text: string,
  url: string
}

export const headerNav: HeaderData[] = [
  {
    text: "About",
    url: "#About"
  }, {
    text: "Services",
    url: "#Services"
  },
  {
    text: "Contact",
    url: "#Contact"
  },
  {
    text: "Book Appointment",
    url: "https://calendly.com/contact-sweptbooks/30min"
  }
]